import {
  type GroupRegistryDocument,
  parseGroupRegistryDocument,
} from "./groupRegistry.document";

export const GROUP_REGISTRY_STORAGE_KEY = "workspace-global-groups-v3";

export type GroupRegistryStorage = Pick<
  Storage,
  "getItem" | "setItem" | "removeItem" | "key" | "length"
>;

export const readGroupRegistryDocument = (
  storage: GroupRegistryStorage = window.localStorage,
): GroupRegistryDocument | undefined => {
  try {
    const raw = storage.getItem(GROUP_REGISTRY_STORAGE_KEY);
    return raw === null
      ? undefined
      : parseGroupRegistryDocument(JSON.parse(raw));
  } catch {
    return undefined;
  }
};

export const writeGroupRegistryDocument = (
  document: GroupRegistryDocument,
  storage: GroupRegistryStorage = window.localStorage,
): boolean => {
  try {
    storage.setItem(GROUP_REGISTRY_STORAGE_KEY, JSON.stringify(document));
    return true;
  } catch {
    return false;
  }
};
